// extracted by mini-css-extract-plugin
export default {"listCompetitors__drawerFooter":"styles_list-competitors__drawer-footer__OoZ-0"};